<template>
  <v-container>
    <MobileHomeCriteria
    :baseCrudKey="baseCrudKey"
    @loadCRUDList="handleMobileTax"/>
    <template>
      <CRUDList
      ref="crudList"
      toolbarTitle="Mobile Home"
      :canAdd="false"
      :canEdit="true"
      :canSave="true"
      :showSelect="false"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :removeHighlightOnDoubleClick="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :formatPidPositions="formatPidPositions"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      tableDynamicHeight='260'
      @loadCRUDList="handleMobileTax"
      @upsertItem="upsertData"
      dialogDynamicWidth="700"
    >
    <template v-slot:[`editedItem`]="{}">
      <TaxMobileDialog :baseCrudKey="baseCrudKey"/>
      </template>
    </CRUDList>
    </template>
    <template><v-row class=" pa-6  align-start ">
  <ClarionDateControl class="input-text-size mr-2" :isToggle="false"
  v-model="printCriteria.fromDate"
  label="From Issue Date" />
  <ClarionDateControl class="input-text-size mr-4" :isToggle="false"
  v-model="printCriteria.toDate"
  label="To Issue Date" />
  <div class=" btns mt-2 " @click.stop="openReport"><v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small  >
                  Print Decal Report
                </v-btn>
              </template>
              <span>Print Decal Report</span>
            </v-tooltip></div>
</v-row></template>
</v-container>
</template>

<script>
import {
  mapMutations, mapState, mapActions, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import MobileHomeCriteria from './MobileHomeCriteria.vue';
import { mobileHomeHeader } from '../TaxInquiryUtils/TableHeaders.utils';
import TaxMobileDialog from '../Common/TaxMobileDialog.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import {
  defaultGridLoading, manageGridLoading,
} from '../../../../util/shared/vue-global';
import { toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import { clients } from '../../../../util/clients';
import { queryStringCalc } from '../Reports/report-util';
import { getRawJwt } from '../../../../util/jwt';
import { useAbortController } from '../../common-utils/tax-common.util';
import '../../../../assets/style.css';

const { backendRest } = clients.direct;

export default {
  name: 'MobileHomeTransactionList',
  components: {
    MobileHomeCriteria,
    CRUDList,
    TaxMobileDialog,
    ClarionDateControl,
  },
  data() {
    return {
      baseCrudKey: 'taxMobile',
      headers: mobileHomeHeader,
      gridLoading: defaultGridLoading(),
      isItFirstCallOrNot: false,
      formatPidPositions: '',
      printCriteria: {
        fromDate: '',
        toDate: '',
      },
      abortController: useAbortController(),
    };
  },
  created() {
    this.initCriteria();
  },
  mounted() {
    if (this.defaultTaxYearFromTaxSetting) {
      this.isItFirstCallOrNot = true;
      // this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      this.handleMobileTax();
    }
    // if (this.latestTaxYear) {
    //   this.isItFirstCallOrNot = true;
    //   this.handleMobileTax();
    // }
  },
  watch: {
    // latestTaxYear(newVal, oldVal) {
    //   if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
    //   if (newVal !== 0) {
    //     this.isItFirstCallOrNot = true;
    //     this.handleMobileTax();
    //   }
    // },
    defaultTaxYearFromTaxSetting(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleMobileTax();
      }
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'criteria',
    ]),
    ...mapState({
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getAuthToken() {
      return getRawJwt();
    },
    queryString() {
      const criteria = {
        fromDate: this.printCriteria.fromDate
          ? toIsoDate(this.printCriteria.fromDate) : this.printCriteria.fromDate,
        toDate: this.printCriteria.toDate
          ? toIsoDate(this.printCriteria.toDate) : this.printCriteria.toDate,
      };
      return queryStringCalc({
        criteria,
        token: this.getAuthToken,
      });
    },
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'upsertTaxInquiryTransaction',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions(['flashError']),
    initCriteria() {
      this.loadConfig({ requiredScope: 'taxConfig' });
      const initialCriteria = this.criteriaState;
      this.criteriaState = {};
      this.criteriaState.taxYear = initialCriteria.taxYear || this.defaultTaxYearFromTaxSetting
       || this.latestTaxYear;
    },
    async handleMobileTax() {
      if (this.isItFirstCallOrNot) {
        this.abortController.abort(); // abort previous fetch here
        this.abortController = useAbortController(); // reinitializing the abourtcontroller
        const { signal } = this.abortController;
        manageGridLoading(this, true, 'Searching...');
        this.formatPidPositions = this.taxSettingItem.pidValue || '';
        const { baseCrudKey } = this;
        const criteria = {
          mobile: true,
          ...this.criteriaState,
        };
        delete criteria.penaltyDateValue;
        const fields = {
          _id: '',
          taxYear: '',
          taxId: '',
          mhPropertyOrParcelId: '',
          schoolDistrict: '',
          mhDescription: '',
          mhVin: '',
          mhTitle: '',
          mhTag: '',
          mhPrice: '',
          mhLocation: '',
          mhType: '',
          mhDecal: '',
          name1: '',
          mhName: '',
          mhMake: '',
          mhDecalDate: '',
          mhTid: '',
          mhYearBuilt: '',
          mhTrustReceipt: '',
          propertyOrParcelId: '',
          certNumber: '',
          pIdOfRealEstate: '',
          taxIdOfRealEstate: '',
        };
        await this.loadTaxInquires({
          criteria, baseCrudKey, fields, postProcessTrans: this.mHPostProcess, signal,
        }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
    mHPostProcess(items) {
      const updatedItem = [];
      for (const value of items) {
        const item = { ...value };
        item.mhDecalDate = item.mhDecalDate ? toShortDate(item.mhDecalDate) : item.mhDecalDate;
        updatedItem.push(item);
      }
      return updatedItem;
    },
    async upsertData(items) {
      const item = items;
      item.mhPropertyOrParcelId = ((item.mhPropertyOrParcelId || '')).replace(/-/g, '');
      item.mhDecalDate = item.mhDecalDate ? toIsoDate(item.mhDecalDate) : null;
      item.taxIdOfRealEstate = item.taxIdOfRealEstate ? Number(item.taxIdOfRealEstate) : null;
      const { baseCrudKey } = this;
      await this.upsertTaxInquiryTransaction({
        item, baseCrudKey, postProcessTrans: this.mHPostProcess,
      });
    },
    searchByCriteria() {
      this.$emit('loadCRUDList');
    },
    openReport() {
      if (!this.printCriteria.fromDate || !this.printCriteria.toDate) {
        this.flashError('From Date and To Date are required for the report');
        return;
      }
      const params = new URLSearchParams();
      if (this.printCriteria.fromDate) {
        params.append('fromDate', toIsoDate(this.printCriteria.fromDate));
      }
      if (this.printCriteria.toDate) {
        params.append('toDate', toIsoDate(this.printCriteria.toDate));
      }
      params.append('token', this.getAuthToken);
      const queryString = params.toString() ? `?${params.toString()}` : '';
      const toUrl = `${backendRest.defaults.baseURL}/taxInquiry/mh-decal-report${queryString}`;
      window.open(toUrl);
    },
  },
};
</script>
